import React from 'react'
import Create from '../crud/create'
import fields from './fields'
import menuItems from './menuItems'

const CreateInstitutionNote = (props) => {
  const baseRecord = {
    institution_id: props.params.institutionId
  }
  return (
    <Create
// @ts-ignore
      title='Add Note to Institution'
      fields={fields}
      resource={baseRecord}
      apiPath='admin/institution_notes'
      successRedirectPath={resource => `/membership/institutions/${resource.institution_id}/notes`}
      buildMenuItems={menuItems}
    />
  )
}

export default CreateInstitutionNote
